'use client';

import type { CredentialsApiDto } from '@terra/shared-contracts-applications';
import type { SseSubscribe } from '@terra/shared-sse-contracts';
import { isCredentialVerificationInProgress } from '@terra/shared-utils';
import { AiBrowserStreamingFrame } from '../chat/components/AiBrowserStreamingFrame';

type Credential = CredentialsApiDto['credentials'][number];

export type CredentialVerificationStreamModalsProps = {
  credentials: Credential[];
  streamingIdByCredentialId: Record<string, string>;
  testingCredentialIds: Set<string>;
  openStreamCredentialId: string | null;
  onOpenStreamCredentialIdChange: (credentialId: string | null) => void;
  onStreamStarted?: (credentialId: string) => void;
  onSSESubscribe: SseSubscribe;
};

export const CredentialVerificationStreamModals = ({
  credentials,
  streamingIdByCredentialId,
  testingCredentialIds,
  openStreamCredentialId,
  onOpenStreamCredentialIdChange,
  onStreamStarted,
  onSSESubscribe,
}: CredentialVerificationStreamModalsProps) => {
  return (
    <>
      {credentials
        .filter((credential) => {
          const streamingId = streamingIdByCredentialId[credential.id];

          if (!streamingId) {
            return false;
          }

          const isTesting = testingCredentialIds.has(credential.id);
          const isVerificationInProgress = isCredentialVerificationInProgress({
            status: credential.verification?.status,
          });

          return isTesting || isVerificationInProgress;
        })
        .map((credential) => {
          const credentialId = credential.id;
          const streamingId = streamingIdByCredentialId[credentialId];

          return (
            <AiBrowserStreamingFrame
              key={credentialId}
              streamingId={streamingId}
              modalOnly
              isModalOpen={openStreamCredentialId === credentialId}
              onModalOpenChange={(open) => {
                onOpenStreamCredentialIdChange(open ? credentialId : null);
              }}
              onStarted={() => {
                onStreamStarted?.(credentialId);
              }}
              onSSESubscribe={onSSESubscribe}
            />
          );
        })}
    </>
  );
};
